"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDrillToAttributeUrl = exports.isDrillToCustomUrl = exports.isDrillToInsight = exports.isDrillToDashboard = exports.isDrillToLegacyDashboard = exports.isDrillFromAttribute = exports.isDrillFromMeasure = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillFromMeasure}.
 * @alpha
 */
function isDrillFromMeasure(obj) {
    return !isEmpty_1.default(obj) && obj.type === "drillFromMeasure";
}
exports.isDrillFromMeasure = isDrillFromMeasure;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillFromAttribute}.
 * @alpha
 */
function isDrillFromAttribute(obj) {
    return !isEmpty_1.default(obj) && obj.type === "drillFromAttribute";
}
exports.isDrillFromAttribute = isDrillFromAttribute;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToLegacyDashboard}.
 * @alpha
 */
function isDrillToLegacyDashboard(obj) {
    return !isEmpty_1.default(obj) && obj.type === "drillToLegacyDashboard";
}
exports.isDrillToLegacyDashboard = isDrillToLegacyDashboard;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToDashboard}.
 * @alpha
 */
function isDrillToDashboard(obj) {
    return !isEmpty_1.default(obj) && obj.type === "drillToDashboard";
}
exports.isDrillToDashboard = isDrillToDashboard;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToInsight}.
 * @alpha
 */
function isDrillToInsight(obj) {
    return !isEmpty_1.default(obj) && obj.type === "drillToInsight";
}
exports.isDrillToInsight = isDrillToInsight;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToCustomUrl}.
 * @alpha
 */
function isDrillToCustomUrl(obj) {
    return !isEmpty_1.default(obj) && obj.type === "drillToCustomUrl";
}
exports.isDrillToCustomUrl = isDrillToCustomUrl;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToAttributeUrl}.
 * @alpha
 */
function isDrillToAttributeUrl(obj) {
    return !isEmpty_1.default(obj) && obj.type === "drillToAttributeUrl";
}
exports.isDrillToAttributeUrl = isDrillToAttributeUrl;
//# sourceMappingURL=drill.js.map